import { type ASTAfterHook, astBuilders as b, astVisit } from '@n8n/tournament';


const forbiddenMembers = ['__proto__', 'prototype', 'constructor', 'getPrototypeOf'];
export const sanitizerName = '__sanitize';
const sanitizerIdentifier = b.identifier(sanitizerName);

export const PrototypeSanitizer: ASTAfterHook = (ast, dataNode) => {
    astVisit(ast, {
        visitMemberExpression(path) {
            this.traverse(path);
            const node = path.node;
            if (!node.computed) {
                // This is static, so we're safe to error here
                if (node.property.type !== 'Identifier') {
                    throw new Error(
                        `Unknown property type ${node.property.type} while sanitising expression`,
                    );
                }

                if (forbiddenMembers.includes(node.property.name)) {
                    throw new Error(
                        `Cannot access "${node.property.name}" due to security concerns`,
                    );
                }
            } else if (node.property.type === 'StringLiteral' || node.property.type === 'Literal') {
                // Check any static strings against our forbidden list
                if (forbiddenMembers.includes(node.property.value as string)) {
                    throw new Error(
                        `Cannot access "${node.property.value as string}" due to security concerns`,
                    );
                }
            } else if (!node.property.type.endsWith('Literal')) {
                // This isn't a literal value, so we need to wrap it
                path.replace(
                    b.memberExpression(

                        node.object as any,

                        b.callExpression(b.memberExpression(dataNode, sanitizerIdentifier), [

                            node.property as any,
                        ]),
                        true,
                    ),
                );
            }
        },
    });
};

export const sanitizer = (value: unknown): unknown => {
    if (forbiddenMembers.includes(value as string)) {
        throw new Error(`Cannot access "${value as string}" due to security concerns`);
    }
    return value;
};
